const { NODE_ENV } = process.env;
const base = '/chat/chat/home/im/';
const prefix = {
    faq: `${base}`,
    im: `${base}im/`,
    form: '/chat/chat/home/form/',
    youpai: {
        development: '/redirect/yxh_feed_up/test/kefu',
        test1: '//dlstest.img4399.com/redirect/yxh_feed_up/test/kefu',
        test2: '//dlstest.img4399.com/redirect/yxh_feed_up/test/kefu',
        ot: '//dlstest.img4399.com/redirect/yxh_feed_up/ot/kefu',
        production: '//up.feed.3304399.net/kefu/'
    }[NODE_ENV],
    dify: {
        development: 'https://chat.for399.com/goproxy/kefu',
        test1: 'https://chat.for399.com/goproxy/kefu',
        test2: 'https://chat.for399.com/goproxy/kefu',
        ot: 'https://ot-knowledge.for399.com/goproxy/kefu',
        production: 'https://knowledge.for399.com/goproxy/kefu'
    }[NODE_ENV]
};
export const CONFIG = (game_key: string): string => `${prefix.im}${game_key}/config`; // 获取游戏配置
export const FAQ_INIT = `${prefix.faq}faq-faqInit`; // faq初始化
export const FAQ_CHECKLABEL = `${prefix.faq}faq-clickLabel`; // 点击热门标签获取faq记录id
export const FAQ_COUNT = `${prefix.faq}faq-count`; // faq问题计数
export const FAQ_SEND = `${prefix.faq}faq-faq`; // faq消息发送
export const FAQ_SOLVE = `${prefix.faq}faq-solve`; // faq解决/未解决
export const FAQ_UNSOLVE_REASON = `${prefix.faq}faq-unSolveReason`; // faq未解决原因
export const FAQ_REPORT = `${prefix.faq}faq-report`; // faq问题上报
export const SYSTYEM_TIME = `${base}faq-now`; // 获取系统时间
export const IM_INIT = (token: string): string => `${prefix.im}${token}init`; // 人工初始化
export const IM_SAVE_CONTACE = (token: string): string => `${prefix.im}${token}saveContact`; // 保存联系方式
export const START = (token: string): string => `${prefix.im}${token}start`; // 开启人工分配
export const IM_PULL = (token: string): string => `${prefix.im}${token}pull`; // 队列
export const IM_EVALUATE = (token: string): string => `${prefix.im}${token}evaluate`; // 评价
export const IM_CLOSE = (token: string): string => `${prefix.im}${token}close`; // 结束会话
export const IM_SEND = (token: string): string => `${prefix.im}${token}send`; // 发送消息
export const IM_SELECT = (token: string): string => `${prefix.im}${token}select`; // 选择客服
export const FORM_TOKEN = `${prefix.form}index-token`; // 获取表单地址
export const IM_COMMENT = (token: string): string => `${prefix.im}${token}comment`; // 留言
export const IM_VIDEO_AUTH = (token: string): string => `${prefix.im}${token}videoAuth`; // 获取视频token
export const IM_VIDEO_URL = (token: string): string => `${prefix.im}${token}videoUrl`; // 获取视频上传地址
export const IM_VIDEO_RECORD = (token: string): string => `${prefix.im}${token}recordVideo`; // 视频超时记录
export const CHUNK = `${prefix.youpai}/v2.0/chunk.html`;
export const CHUNK_START = `${prefix.youpai}/v2.0/start.html`;
export const CHUNK_END = `${prefix.youpai}/v2.0/end.html`;
export type FAQWorkflowFlow = 1 | 2;

let faqWorkflowFlow: FAQWorkflowFlow = 1;

export const setFAQWorkflowFlow = (flow: unknown): void => {
    faqWorkflowFlow = Number(flow) === 2 ? 2 : 1;
};

export const isFAQSopWorkflow = (): boolean => faqWorkflowFlow === 2;
export const getFAQWorkflowName = (): 'faq-image' | 'kefu-sop' =>
    isFAQSopWorkflow() ? 'kefu-sop' : 'faq-image';
export const FAQ_WORKFLOWS_RUN = (): string =>
    `${prefix.dify}/${getFAQWorkflowName()}/chat-messages`;
export const FAQ_STOP_FLOW = `${prefix.faq}faq-stopFlow`;
export const FAQ_WORKFLOW_LOG = `${prefix.faq}faq-workflowLog`;
